const BAR_HEIGHTS = [38, 62, 48, 78, 44, 70, 52, 85, 46, 74, 58, 66, 42, 72, 55, 80];

function ChartSkeleton() {
  return (
    <div className="live-chart-wrap" aria-busy="true" aria-label="Loading chart">
      <div className="live-chart-surface chart-skeleton">
        <span className="chart-skeleton__sr">Loading chart data…</span>
        <div className="chart-skeleton__plot">
          <div className="chart-skeleton__y-axis" aria-hidden />
          <div className="chart-skeleton__bars" aria-hidden>
            {BAR_HEIGHTS.map((height, index) => (
              <div key={index} className="chart-skeleton__bar-col">
                <div className="chart-skeleton__bar" style={{ height: `${height}%` }} />
              </div>
            ))}
          </div>
        </div>
        <div className="chart-skeleton__x-axis" aria-hidden />
      </div>
    </div>
  );
}

export default ChartSkeleton;
